import { Environment } from '@integration-frontends/apps/common/utils/environment-types';

export const environment = {
  production: true,
  bfBaseUrl: 'https://brandfolder.com/api',
  bfWebsiteBaseUrl: 'https://brandfolder.com',
  bfStaticAssetsBaseUrl: 'https://static-fast.brandfolder.com',
  hostUrl: 'https://integration-panel-ui.brandfolder-svc.com',
  segmentWriteKey: 'mXNgAITR8qQXLuSX6OlUYlzkdn5wFtMD',
  oauthBaseUrl: 'https://oauth2.brandfolder-apps.com',
  oauthClientId: 'integration-panel-ui-app',
  environment: Environment.Production,
};
